function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Button from '../../Button';
import Selection from './Selection';
import Option from './Option';
/**
 * The MenuOption component is a collaborator of DropdownMenu component and
 * is like the `option` element within `select`. It represents an option
 * within a list of options
 *
 * - [MDN option element docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/option)
 *
 * ## Related Components
 * - [DropdownMenu](../DropdownMenu/README.md)
 * - [MenuGroup](../MenuGroup/README.md)
 *
 * ## Usage
 *
 * See `DropdownMenu` usage.
 */

var MenuOption = /*#__PURE__*/function (_PureComponent) {
  _inherits(MenuOption, _PureComponent);

  var _super = _createSuper(MenuOption);

  function MenuOption() {
    _classCallCheck(this, MenuOption);

    return _super.apply(this, arguments);
  }

  _createClass(MenuOption, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          qa = _this$props.qa,
          selected = _this$props.selected,
          disabled = _this$props.disabled,
          alert = _this$props.alert,
          variant = _this$props.variant,
          primaryText = _this$props.primaryText,
          secondaryText = _this$props.secondaryText,
          tertiaryText = _this$props.tertiaryText,
          iconType = _this$props.iconType;
      var OptionLayout = variant === 'selection' || variant === 'darkSelection' ? Selection : Option;
      var buttonActive = variant === 'darkSelection' ? false : selected;
      return /*#__PURE__*/React.createElement(Button, _extends({}, this.props, {
        qa: "".concat(qa, "#selectOption"),
        active: buttonActive,
        variant: "option",
        id: iconType
      }), /*#__PURE__*/React.createElement(OptionLayout, {
        className: "psw-p-5",
        qa: qa,
        selected: selected,
        disabled: disabled,
        iconType: iconType,
        primaryText: primaryText,
        alert: alert,
        secondaryText: secondaryText,
        tertiaryText: tertiaryText
      }));
    }
  }]);

  return MenuOption;
}(PureComponent);

MenuOption.defaultProps = {
  qa: '',
  className: '',
  value: '',
  selected: false,
  variant: 'selection',
  disabled: false,
  alert: null,
  primaryText: '',
  secondaryText: '',
  tertiaryText: '',
  ariaLabel: '',
  trackClick: null,
  telemetryMeta: null,
  onClick: function onClick() {},
  iconType: ''
};
MenuOption.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * The value associated with the option
   */
  value: PropTypes.string,

  /**
   * whether the option is selected or not
   */
  selected: PropTypes.bool,

  /**
   * Whether or not the option can be selected
   */
  disabled: PropTypes.bool,

  /*
   * AlertBubble to be included in option content
   */
  alert: PropTypes.node,

  /**
   * Primary accepted for option dropdown options
   */
  primaryText: PropTypes.string,

  /**
   * Secondary accepted for option dropdown options
   */
  secondaryText: PropTypes.string,

  /**
   * Tertiary accepted for option dropdown options
   */
  tertiaryText: PropTypes.string,

  /*
   * sets the type of dropdown Menu
   */
  variant: PropTypes.oneOf(['selection', 'option', PropTypes.string]),

  /**
   * event callback to be called when a user clicks on the button or children within
   */
  onClick: PropTypes.func,

  /**
   * Aria label for button. Be aware that screen reader will always use this value if provided
   */
  ariaLabel: PropTypes.string,

  /**
   * The spec id identifying the interaction
   */
  trackClick: PropTypes.string,

  /**
    * Serialized json data of context specific telemetry data
    */
  telemetryMeta: PropTypes.string,

  /**
    * String of the icon type to be shown in the cta
    */
  iconType: PropTypes.string
};
export default MenuOption;